export default (context, data) => {

    let button = document.getElementById('player-component__button')
    button.style.display = 'block'
    context.videos.forEach((item, index) => {
        if(data.index === index) {
            context.videos[index].status = !context.videos[index].status

            let el = document.getElementById('player-component__container')

            if(!context.videos[index].status) {

                context.temporaryData = false
                button.style.display = 'none'
                el.style.opacity = 0;
                let container = document.getElementsByClassName('add-ending-select-page__container')[0]
                container.style.backgroundImage = 'none'
                container.style.backgroundPosition = 'none'
                container.style.backgroundRepeat = 'none'
                container.style.backgroundSize = 'none'

            } else {
                context.temporaryData = data
                el.style.opacity = 1;

                const checkElement = () => {
                    let id = document.getElementById('player-component__container')
                    let video = document.getElementById('player-component__video')

                    if( id && video ) {
                        let container = document.getElementsByClassName('add-ending-select-page__container')[0]
                        container.style.backgroundImage = `url(${require('~/assets/' + 'space.jpg')}`
                        container.style.backgroundPosition = 'center center'
                        container.style.backgroundRepeat = 'no-repeat'
                        container.style.backgroundSize = 'cover'

                    } else {
                        setTimeout(() => {
                            checkElement()
                        }, 100);
                    }
                }

                checkElement()

            }

        } else {
            context.videos[index].status = false
        }
    })
}